export const blankHtmlTemplate = `<!doctype html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
    img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; max-width: 100%; }
  </style>
</head>
<body style="background-color:#ffffff; margin: 0; padding: 20px;">

  <!-- Simple Container -->
  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation"
         style="max-width:600px; width:100%; margin:0 auto;">

    <!-- Main Content -->
    <tr>
      <td style="padding: 20px; text-align: {{align}}; direction: {{direction}};">
        <div style="color: #333333; font-family: Arial, sans-serif; font-size: 16px; line-height: 1.7;">
          {{{text}}}
        </div>
      </td>
    </tr>

    <!-- CTA Button (optional) -->
    {{#if bwLink}}
    <tr>
      <td style="padding: 20px; text-align: center;">
        <a href="{{bwLink}}" target="_blank"
           style="display: inline-block; background-color: #1a365d; color: #ffffff; font-family: Arial, sans-serif; font-size: 16px; font-weight: bold; padding: 14px 30px; text-decoration: none; border-radius: 6px;">
          {{#if btnLabel}}{{btnLabel}}{{else}}Read More{{/if}}
        </a>
      </td>
    </tr>
    {{/if}}

    <!-- Optional Footer Content -->
    {{#unless footer}}
    {{#if footerText}}
    <tr>
      <td style="padding: 20px; border-top: 1px solid #eeeeee; text-align: {{align}}; direction: {{direction}};">
        <div style="color: #555555; font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6;">
          {{{footerText}}}
        </div>
      </td>
    </tr>
    {{/if}}
    {{/unless}}

  </table>

  <!-- Unsubscribe (required by Mailgun) -->
  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="max-width:600px; width:100%; margin:20px auto 0;">
    <tr>
      <td style="text-align: center; padding: 10px;">
        <p style="margin: 0; color: #999999; font-family: Arial, sans-serif; font-size: 11px;">
          <a href="#" style="color: #999999;">Unsubscribe</a>
        </p>
      </td>
    </tr>
  </table>

</body>
</html>`;
